import { FC, useEffect, useState } from 'react';
import { Slider } from 'antd';
import { TbArrowUpRight, TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';
import { PlatformAlert } from '@/shared/components/alerts';
import { PlatformForm as Form } from '@/shared/components/forms';

interface ESGProps {
    filters: any;
    handleChange: any;
}

const ESG: FC<ESGProps> = ({ filters, handleChange }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { hasMinimumPlan } = useEntitlements();
    const { token } = useAntDesignTheme();

    return !hasMinimumPlan('plus') ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
            <PlanTag plan={'plus'} style={{ marginLeft: '0.5rem' }} />
        </div>
    ) : (
        <>
            <PlatformAlert
                title='ESG coverage'
                showIcon
                status='info'
                icon={
                    <TbInfoCircle
                        size='1.125rem'
                        style={{
                            marginRight: '0.75rem',
                            marginTop: '0.1rem',
                        }}
                    />
                }
                description={
                    <span>
                        ESG weightings are applied either on a per-company or per-sector basis. Click here to learn more
                        about{' '}
                        <a
                            href='https://www.investopedia.com/terms/e/environmental-social-and-governance-esg-criteria.asp'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            ESG scores
                            <TbArrowUpRight style={{ verticalAlign: '-0.15rem', marginLeft: '0.125rem' }} />
                        </a>
                    </span>
                }
                style={{ marginBottom: '0.75rem' }}
            />
            <Form layout='vertical'>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label={<span style={{ color: token.colorTextTertiary }}>Environmental Score</span>}
                >
                    <Slider
                        range
                        value={[filters?.esg?.environmental?.min, filters?.esg?.environmental?.max]}
                        onChange={(values) =>
                            handleChange(['esg', 'environmental'], {
                                min: values[0],
                                max: values[1],
                            })
                        }
                        max={100}
                        min={1}
                        step={1}
                    />
                </Form.Item>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label={<span style={{ color: token.colorTextTertiary }}>Social Score</span>}
                >
                    <Slider
                        range
                        value={[filters?.esg?.social?.min, filters?.esg?.social?.max]}
                        onChange={(values) =>
                            handleChange(['esg', 'social'], {
                                min: values[0],
                                max: values[1],
                            })
                        }
                        max={100}
                        min={1}
                        step={1}
                    />
                </Form.Item>
                <Form.Item
                    style={{ marginBottom: 0 }}
                    label={<span style={{ color: token.colorTextTertiary }}>Goverance Score</span>}
                >
                    <Slider
                        range
                        value={[Number(filters?.esg?.governance?.min), Number(filters?.esg?.governance?.max)]}
                        onChange={(values) =>
                            handleChange(['esg', 'governance'], {
                                min: values[0],
                                max: values[1],
                            })
                        }
                        step={1}
                        max={100}
                        min={1}
                    />
                </Form.Item>
            </Form>
        </>
    );
};

export default ESG;
